module.exports = __webpack_public_path__ + "img/doc-review.09c1c410.svg";